import React, { useEffect, useState } from "react";
import '../../CSS/Empleados.css'
import {BsPlus} from "react-icons/bs";
import { getPermission} from '../../Conexiones/Conexion';
//import moment from "moment/moment";
import ModalPin from "./ModalPin";
import { useNavigate } from "react-router";
import { deleteApi, getApi, postApi, putApi } from "../../Conexiones/Models";
import { errorMessage, errorToast, successToast, warningModal, warningToast } from "../../Utils/AlertMessage";
import { FaArrowLeftLong } from "react-icons/fa6";
import { Button, CloseButton, Modal } from "react-bootstrap";
import Loading from '../../Utils/Loading';

function EmpleadosCampo() {
    const [empleados, setEmpleados] = useState([]);
    const [tablaEmpleados, setTablaEmpleados] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;
    const navigate = useNavigate();
    const uri = 'empleados/';
    const [isSaving, setSaving] = useState(false);
    const [isLoading,setIsLoading]=useState(false);

    useEffect( ()=>{
        const getEmpleados = async () =>{
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,10);
            if(permiso){
                const endpoint = 'empleados-campo/';
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setEmpleados(res.data)
                        setTablaEmpleados(res.data)
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio')
            }
            setIsLoading(false);
        }
        getEmpleados()
    }, [navigate,idUsuario]);

    const getEmpleadosCam = async () =>{
        const endpoint = 'empleados-campo/';
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setEmpleados(res.data)
                setTablaEmpleados(res.data)
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    const buscar = e => {
        setBusqueda(e.target.value)
        filtrar(e.target.value)
    }

    const filtrar = (texto) => {
        var resBusqueda = tablaEmpleados.filter((elemento)=> {
            if  (elemento.nombreEmp.toString().toLowerCase().includes(texto.toLowerCase()) || 
            elemento.codigoEmp.toString().toLowerCase().includes(texto.toLowerCase()) ||
            elemento.nombreArea.toString().toLowerCase().includes(texto.toLowerCase()) ||
            elemento.nombrePuesto.toString().toLowerCase().includes(texto.toLowerCase())
            ){  
                return elemento; 
            }
            return resBusqueda
        })
        setEmpleados(resBusqueda)
    }

    const regresar = () => {
        navigate('/inicio/Catalogos/Empleados')
    }
    const [puestos,setPuestos] = useState([])
    const [areas,setAreas] = useState([])
    const getAreas = async () =>{
        const endpoint = 'areas/';
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setAreas(res.data)
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }
    const getPuestos = async () =>{
        const endpoint = 'puestos/';
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setPuestos(res.data)
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    const [idEmp,setIdEmp] = useState('')
    const [codigo, setCodigo] = useState('')
    const [nombre, setNombre] = useState('')
    const [apePat, setApePat] = useState('')
    const [apeMat, setApeMat] = useState('')
    const [correo, setCorreo] = useState('')
    const [telefono, setTelefono] = useState('')
    const [fecha, setFecha] = useState('')
    const [sexo, setSexo] = useState('')
    const [sueldo, setSueldo] = useState()
    const [seguro, setSeguro] = useState('')
    const [area, setArea] = useState(0)
    const [puesto, setPuesto] = useState(0)

    const data ={
        nombreEmp: nombre, apellidoPaternoEmp: apePat,
        apellidoMaternoEmp: apeMat, correoEmp: correo,
        telefonoEmp: telefono, fechaNacEmp: fecha,
        sexoEmp: sexo, sueldoEmp: sueldo, seguroEmp: seguro,
        idArea: area, idPuesto: puesto
    }

    //AGREGAR
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const showAddEmp = async () => {
        await getAreas();
        await getPuestos();
        handleShow();
    }
    const closeAddEmp = () =>{
        handleClose()
        setNombre('')
        setApePat('')
        setApeMat('')
        setCorreo('')
        setTelefono('')
        setFecha('')
        setSexo('')
        setSueldo()
        setSeguro('')
        setArea(0)
        setPuesto(0)
    }

    const store = async (e) =>{
        setSaving(true)
        e.preventDefault()
        if(nombre.trim().length === 0 | apePat.trim().length === 0 | sexo === '' | area === 0 | puesto === 0){
            warningToast('CAMPOS VACIOS','EL CAMPO NOMBRE, APELLIDO PATERNO, SEXO, AREA O PUESTO ESTA VACÍO');
        }else{
            const endpoint = uri;
            const res = await postApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="¡EMPLEADO AGREGADO CORRECTAMENTE!"){
                    closeAddEmp();
                    getEmpleadosCam();
                    successToast("AGREGADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSaving(false)
    }

    const modalDelete = (id) => {
        warningModal('¿QUIERES ELIMINAR ESTE EMPLEADO?')
        .then(async (result) => {
            if (result.isConfirmed) {
                const endpoint = uri + id;
                const res = await deleteApi(endpoint);
                if(res.status === 1){
                    if(res.data.message==="¡Registro eliminado correctamente!"){
                        getEmpleadosCam();
                        successToast("ELIMINADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }
        })
    }

    //Editar
    const [showUd, setShowUd] = useState(false);
    const handleCloseUd = () => setShowUd(false);
    const handleShowUd = () => setShowUd(true);
    const showUpdEmp = async (ide) => {
        const id = ide;
        await getAreas();
        await getPuestos();
        const endpoint = uri + id;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setIdEmp(res.data[0].idEmpleado)
                setCodigo(res.data[0].codigoEmp)
                setNombre(res.data[0].nombreEmp)
                setApePat(res.data[0].apellidoPaternoEmp)
                setApeMat(res.data[0].apellidoMaternoEmp)
                setCorreo(res.data[0].correoEmp)
                setTelefono(res.data[0].telefonoEmp)
                setFecha(res.data[0].fechaNacEmp)
                setSexo(res.data[0].sexoEmp)
                setSueldo(res.data[0].sueldoEmp)
                setSeguro(res.data[0].seguroEmp)
                setArea(res.data[0].idArea)
                setPuesto(res.data[0].idPuesto)
                handleShowUd();
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }
    const closeUpdEmp = () =>{
        handleCloseUd()
        setCodigo('')
        setNombre('')
        setApePat('')
        setApeMat('')
        setCorreo('')
        setTelefono('')
        setFecha('')
        setSexo('')
        setSueldo()
        setSeguro('')
        setArea(0)
        setPuesto(0)
    }
    const update = async (e) =>{
        setSaving(true)
        e.preventDefault()
        if(nombre.trim().length === 0 | apePat.trim().length === 0 | sexo === '' | area === 0 | puesto === 0){
            warningToast('CAMPOS VACIOS','EL CAMPO NOMBRE, APELLIDO PATERNO, SEXO, AREA O PUESTO ESTA VACÍO');
        }else{
            const endpoint = uri + idEmp;
            const res = await putApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="¡EMPLEADO MODIFICADO CORRECTAMENTE!"){
                    closeUpdEmp();
                    getEmpleadosCam();
                    successToast("EDITADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSaving(false)
    }

    //Modal PIN
    const [showP, setShowP] = useState(false);
    const handleCloseP = () => setShowP(false);
    const handleShowP = () => setShowP(true);
    const [idE,setIdE] = useState('');
    const [codE,setCodE] = useState('');
    const [nomE,setNomE] = useState('');
    const [apE,setApE] = useState('');
    const [amE,setAmE] = useState('');
    const modalPin = (id,cod,nom,ap,am) => {
        setIdE(id);
        setCodE(cod);
        setNomE(nom);
        setApE(ap);
        setAmE(am);
        handleShowP();
    }

    return (
        <div className='empleados' >
            {
                isLoading ? 
                <Loading />:
                <div>
                    <ModalPin show={showP} handleClose={handleCloseP} idEmp={idE} codEmp={codE} nomEmp={nomE} apePat={apE} apeMat={amE}/>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">GESTIÓN DE EMPLEADOS DE CAMPO</label>
                    </div>
                    <div className='divbotonE' >                                                                                             
                        <div className='botonE' style={{display:'flex', justifyContent:'space-between'}} >
                            <button  className="btn btn-light btncolor" onClick={showAddEmp} type="button">
                                <label className="agregar">EMPLEADO</label><BsPlus style={{fontSize:'25px'}}/>
                            </button>
                            <input className="form-control" value={busqueda} onChange={buscar} style={{width:'50%'}} type="search" placeholder="Buscar" aria-label="Search"/>                    
                        </div>
                    </div>
                    {
                        empleados.length === 0 ? (<h3 style={{marginTop:'30vh'}}>AUN NO HAY REGISTROS</h3>):(
                            <div className="tabla-cajaE" >
                                <div className="table tabla">
                                    <table className="table table-hover table-bordered ">
                                        <thead className="encabezado">
                                            <tr >
                                                <th>CODIGO</th>
                                                <th>NOMBRE</th>
                                                <th>CORREO</th>
                                                <th>TELEFONO</th>
                                                {/*<th>FECHA NACIMIENTO</th>*/}
                                                <th>SEXO</th>
                                                <th>SUELDO SEMANAL</th>
                                                <th>SEGURO</th>
                                                <th>AREA</th>
                                                <th>PUESTO</th>
                                                <th >ACCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            {empleados.map(empleado =>{
                                                return(                                    
                                                    <tr key={empleado.idEmpleado}>
                                                    <td valign="middle" className="text-uppercase">{empleado.codigoEmp}</td>
                                                    <td valign="middle" className="text-uppercase">
                                                        {empleado.nombreEmp+' '+empleado.apellidoPaternoEmp+' '+empleado.apellidoMaternoEmp}
                                                    </td>
                                                    {empleado.correoEmp === empleado.codigoEmp ? (
                                                        <td></td>
                                                    ):(
                                                        <td valign="middle">{empleado.correoEmp}</td>
                                                    )}
                                                    
                                                    <td valign="middle" className="text-uppercase">{empleado.telefonoEmp}</td>
                                                    {/*<td valign="middle" className="text-uppercase">{moment(empleado.fechaNacEmp).format("DD/MM/YYYY")}</td>*/}
                                                    {empleado.sexoEmp === "m" ? (
                                                        <td valign="middle" className="text-uppercase">Masculino</td>
                                                    ):(<td valign="middle" className="text-uppercase">Femenino</td>)}                                    
                                                    <td valign="middle">$ {empleado.sueldoEmp % 1 === 0 ? (Number.parseFloat(empleado.sueldoEmp).toFixed(2)):(empleado.sueldoEmp) }</td>
                                                    <td valign="middle" className="text-uppercase">{empleado.seguroEmp}</td>
                                                    <td valign="middle" className="text-uppercase">{empleado.nombreArea}</td>
                                                    <td valign="middle" className="text-uppercase">{empleado.nombrePuesto}</td>
                                                    <td valign="middle">
                                                        <div style={{display:'flex'}}>
                                                            <div className="btn iconoE" onClick={() => showUpdEmp(empleado.idEmpleado)} style={{margin:'1px'}}>
                                                                <span className="bi bi-pen" title="EDITAR"></span>
                                                            </div>                                            
                                                            <div className="btn iconoE" style={{margin:'1px'}} onClick={() => modalDelete(empleado.idEmpleado)}>
                                                                <span className="bi bi-trash" title="ELIMINAR"></span>
                                                            </div> 
                                                            <div className="btn iconoE" style={{margin:'1px'}} onClick={() => modalPin(empleado.idEmpleado,empleado.codigoEmp,empleado.nombreEmp,empleado.apellidoPaternoEmp,empleado.apellidoMaternoEmp)}>
                                                                <span className="bi bi-lock" title="MODIFICAR PIN"></span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                )
                                            })}                        
                                        </tbody>
                                    </table>
                                </div>           
                            </div>
                        )
                    }

                    {/*AGREGAR EMPLEADO CAMPO*/}
                    <Modal show={show} onHide={handleClose} id="modal-agregar-empleadoCampo">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>AGREGAR EMPLEADO</Modal.Title>
                            <CloseButton  style={{backgroundColor:"white"}} onClick={closeAddEmp} />
                        </Modal.Header>
                        <form onSubmit={store}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', height:'60vh', overflowY:"scroll"}}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">NOMBRE <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="text" className="form-control"  id="exampleFormControlInput1" required 
                                    onChange={e => setNombre(e.target.value) }/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput2" className="form-label">APELLIDO PATERNO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="text" className="form-control"  id="exampleFormControlInput2" required
                                    onChange={e => setApePat(e.target.value) }/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput3" className="form-label">APELLIDO MATERNO</label>
                                    <input type="text" className="form-control"  id="exampleFormControlInput3"
                                    onChange={e => setApeMat(e.target.value) }/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput4" className="form-label">CORREO</label>
                                    <input type="email" className="form-control"  id="exampleFormControlInput4"
                                    onChange={e => setCorreo(e.target.value) }/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput5" className="form-label">TELEFONO</label>
                                    <input type="number" className="form-control"  id="exampleFormControlInput5" minLength={10} maxLength={10}
                                    onChange={e => setTelefono(e.target.value) }/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput6" className="form-label">FECHA DE INGRESO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="date" className="form-control" id="exampleFormControlInput6" required
                                    onChange={e => setFecha(e.target.value) }/>
                                </div>
                                <div className="mb-3 ">
                                    <label htmlFor="exampleFormControlInput7" className="form-label">SEXO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <select className="form-control" required 
                                    onChange={e => setSexo(e.target.value) }   >
                                        <option >--Seleccione una opción--</option>
                                        <option value="f" >FEMENINO</option>
                                        <option value="m">MASCULINO</option>
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput8" className="form-label">SUELDO (SEMANAL)<label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="number" onWheel={event=>event.currentTarget.blur()} className="form-control"  id="exampleFormControlInput8" step="any" min={0} required
                                    onChange={e => setSueldo(e.target.value) }/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput9" className="form-label">SEGURO SOCIAL <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <div onChange={e => setSeguro(e.target.value)} >
                                        <div className="form-check" >
                                            <input className="form-check-input" type="radio" value="si" name="seguro" id="flexRadioDefault10" required/>
                                            <label className="form-check-label" htmlFor="flexRadioDefault10">
                                                SI
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" value="no" name="seguro" id="flexRadioDefault11" />
                                            <label className="form-check-label" htmlFor="flexRadioDefault11">
                                                NO
                                            </label>
                                        </div>                               
                                    </div>
                                </div>
                                <div className="mb-3 ">
                                    <label htmlFor="exampleFormControlInput12" className="form-label">AREA <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <select className="form-control text-uppercase" required 
                                        onChange={e => setArea(e.target.value) }   >
                                        <option >--Seleccione una opción--</option>
                                        {areas.map(are => {
                                            return(
                                                <option key={are.idArea} value={are.idArea}>{are.nombreArea}</option>
                                            )
                                        })
                                        }                                
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput13" className="form-label">PUESTO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <select className="form-control text-uppercase" required 
                                        onChange={e => setPuesto(e.target.value) }   >
                                        <option >--Seleccione una opción--</option>
                                        {puestos.map(pue => {
                                            return(
                                                <option key={pue.idPuesto} value={pue.idPuesto}>{pue.nombrePuesto}</option>
                                            )
                                        })
                                        }                                
                                    </select>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={closeAddEmp}>CANCELAR</Button>                                               
                                {isSaving===true?
                                    <Button className="btn btn-primary" type="button" disabled >
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                
                                }
                            </Modal.Footer>
                        </form>
                    </Modal>

                    {/*EDITAR EMPLEADO CAMPO*/}
                    <Modal show={showUd} onHide={handleCloseUd} id="modal-editar-empleadoCampo">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>EDITAR EMPLEADO</Modal.Title>
                            <CloseButton  style={{backgroundColor:"white"}} onClick={closeUpdEmp} />
                        </Modal.Header>
                        <form onSubmit={update}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', height:'60vh', overflowY:"scroll"}}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">NOMBRE <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="text" value={nombre} className="form-control"  id="exampleFormControlInput1" required 
                                    onChange={e => setNombre(e.target.value) }/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput2" className="form-label">APELLIDO PATERNO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="text" value={apePat} className="form-control"  id="exampleFormControlInput2" required
                                    onChange={e => setApePat(e.target.value) }/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput3" className="form-label">APELLIDO MATERNO</label>
                                    <input type="text" value={apeMat} className="form-control"  id="exampleFormControlInput3"
                                    onChange={e => setApeMat(e.target.value) }/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput4" className="form-label">CORREO</label>
                                    {correo === codigo ? (
                                        <input type="email" className="form-control"  id={"exampleFormControlInput4"+idEmp}
                                        value={""} onChange={e => setCorreo(e.target.value) }/>
                                    ):(
                                        <input type="email" className="form-control"  id={"exampleFormControlInput4"+idEmp}
                                    value={correo} onChange={e => setCorreo(e.target.value) }/>
                                    )}
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput5" className="form-label">TELEFONO</label>
                                    <input type="number" value={telefono} className="form-control"  id="exampleFormControlInput5" minLength={10} maxLength={10}
                                    onChange={e => setTelefono(e.target.value) }/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput6" className="form-label">FECHA DE INGRESO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="date" value={fecha} className="form-control" id="exampleFormControlInput6" required
                                    onChange={e => setFecha(e.target.value) }/>
                                </div>
                                <div className="mb-3 ">
                                    <label htmlFor="exampleFormControlInput7" className="form-label">SEXO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <select className="form-control" value={sexo} required 
                                    onChange={e => setSexo(e.target.value) }   >
                                        <option >--Seleccione una opción--</option>
                                        <option value="f" >FEMENINO</option>
                                        <option value="m">MASCULINO</option>
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput8" className="form-label">SUELDO (SEMANAL)<label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="number" value={sueldo} onWheel={event=>event.currentTarget.blur()} className="form-control"  id="exampleFormControlInput8" step="any" min={0} required
                                    onChange={e => setSueldo(e.target.value) }/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput9" className="form-label">SEGURO SOCIAL <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <div onChange={e => setSeguro(e.target.value)} >
                                        <div className="form-check" >
                                            <input className="form-check-input" type="radio" value="si" name="seguro" id="flexRadioDefault10" required
                                            checked={seguro==="si"} readOnly/>
                                            <label className="form-check-label" htmlFor="flexRadioDefault10">
                                                SI
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" value="no" name="seguro" id="flexRadioDefault11" 
                                            checked={seguro==="no"} readOnly/>
                                            <label className="form-check-label" htmlFor="flexRadioDefault11">
                                                NO
                                            </label>
                                        </div>                               
                                    </div>
                                </div>
                                <div className="mb-3 ">
                                    <label htmlFor="exampleFormControlInput12" className="form-label">AREA <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <select className="form-control text-uppercase" value={area} required 
                                        onChange={e => setArea(e.target.value) }   >
                                        <option >--Seleccione una opción--</option>
                                        {areas.map(are => {
                                            return(
                                                <option key={are.idArea} value={are.idArea}>{are.nombreArea}</option>
                                            )
                                        })
                                        }                                
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput13" className="form-label">PUESTO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <select className="form-control text-uppercase" value={puesto} required 
                                        onChange={e => setPuesto(e.target.value) }   >
                                        <option >--Seleccione una opción--</option>
                                        {puestos.map(pue => {
                                            return(
                                                <option key={pue.idPuesto} value={pue.idPuesto}>{pue.nombrePuesto}</option>
                                            )
                                        })
                                        }                                
                                    </select>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={closeUpdEmp}>CANCELAR</Button>                                               
                                {isSaving===true?
                                    <Button className="btn btn-primary" type="button" disabled >
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                
                                }
                            </Modal.Footer>
                        </form>
                    </Modal>
                </div>
            }   
        </div>
    )
}

export default EmpleadosCampo